module.exports = __webpack_public_path__ + "static/media/ministryofcoin_icon_light.b0c6eeb0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/ministryofcoin_icon_light.svg
// module id = 902
// module chunks = 0